import { useEffect, useRef } from "react";
import {  useNavigate } from "react-router-dom";
import videojs from "video.js";
import "video.js/dist/video-js.css";

function VideoPlayer({ url }) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

   const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);


  useEffect(() => {
    if (!url) return;

    const videoElement = document.createElement("video");
    videoElement.className =
      "video-js vjs-default-skin vjs-big-play-centered";
    videoElement.style.width = "100%";
    videoElement.style.height = "100%";

    // 🔐 Security attributes
    videoElement.setAttribute(
      "controlsList",
      "nodownload noremoteplayback"
    );
    videoElement.setAttribute("disablePictureInPicture", "true");
    videoElement.setAttribute("playsinline", "true");

    // Disable right click
    videoElement.oncontextmenu = (e) => e.preventDefault();

    videoRef.current.appendChild(videoElement);

    const player = (playerRef.current = videojs(videoElement, {
      autoplay: true,
      controls: true,
      responsive: true,
      fluid: false,
      playbackRates: [0.5, 1, 1.25, 1.5, 2],
      controlBar: {
        volumePanel: { inline: false },
        skipButtons: {
          forward: 10,
          backward: 10,
        },
        pictureInPictureToggle: false,
      },
      sources: [
        {
          src: url,
          type: "video/mp4",
        },
      ],
    }));

    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [url]);

  return (
    <div className="w-full h-full">
      <div ref={videoRef} className="w-full h-full" />
    </div>
  );
}

export default VideoPlayer;